module.exports = __webpack_public_path__ + "static/media/pmr-logo.2c5999ac.png";